import types from 'actions/types'
import { createPivotTableReducer } from 'reducers/pivotTable'
import { combineReducers } from 'redux'

export const showPosted = (state = false, action) => {
  switch (action.type) {
    case types.QUOTING_INVOICES_UPDATE_FILTERS: return (action.filters.hasOwnProperty('showPosted')) ? action.filters.showPosted : state
    default: return state
  }
}

export const invoicesTabPivotTableKey = 'quotingContext.selected.invoicesTab.pivotTable'

export default combineReducers({
  showPosted,
  pivotTable: createPivotTableReducer({key: invoicesTabPivotTableKey, defaultSortColumn: 'startDate'}),
})
